import { render } from "./Upload.vue?vue&type=template&id=b8c8e72e&scoped=true"
import script from "./Upload.vue?vue&type=script&lang=js"
export * from "./Upload.vue?vue&type=script&lang=js"

import "./Upload.vue?vue&type=style&index=0&id=b8c8e72e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b8c8e72e"

export default script